const skylineStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'flex-end',
  height: 'min(65dvh, 580px)',
  overflow: 'hidden',
  zIndex: 0,
};

const imgStyle: React.CSSProperties = {
  height: '100%',
  width: '20%',
  objectFit: 'cover',
  objectPosition: 'top center',
  opacity: 0.25,
  filter: 'contrast(3)',
};

const images = [
  '/assets/kings-outline.png',
  '/assets/bridge-outline.png',
  '/assets/radcam-outline.png',
  '/assets/gatehouse-outline.png',
  '/assets/magdalen-outline.png',
];

export const AuthSkyline = ({ light, extraLight, fixed }: { light?: boolean; extraLight?: boolean; fixed?: boolean }) => {
  const resolvedStyle = extraLight
    ? { ...imgStyle, opacity: 0.08, filter: 'contrast(1.5)' }
    : light
    ? { ...imgStyle, opacity: 0.15, filter: 'contrast(2.5)' }
    : imgStyle;

  return (
    <div style={{ ...skylineStyle, ...(fixed ? { position: 'fixed' } : {}) }}>
      {images.map((src) => (
        <img key={src} src={src} alt="" style={resolvedStyle} />
      ))}
    </div>
  );
};
